'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.CTAType = void 0;
(function (CTAType) {
    CTAType["DEEPLINK"] = "DEEPLINK";
    CTAType["STATIC"] = "CLOSE_BOTTOMSHEET_CTA";
    CTAType["PLAN_PURCHASE"] = "PLAN_PURCHASE_CTA";
})(exports.CTAType || (exports.CTAType = {}));
//# sourceMappingURL=type.js.map
